// https://app.growthbook.io/features/prcng-1266_v1
export const CM_DUAL_CTA_FLAG_NAME = 'prcng-1266_v1'
